import { render, staticRenderFns } from "./shopUserIntegral.vue?vue&type=template&id=22a817be&scoped=true"
import script from "./shopUserIntegral.vue?vue&type=script&lang=js"
export * from "./shopUserIntegral.vue?vue&type=script&lang=js"
import style0 from "./shopUserIntegral.vue?vue&type=style&index=0&id=22a817be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a817be",
  null
  
)

export default component.exports